import { Text } from '@doordash/design-language'
import { get, uniqueId } from 'lodash'
import * as React from 'react'
import SignatureCanvas from '../../atoms/signature-canvas'
import { AddressHistory } from '../../organisms/address-history'
import { AliasHistory } from '../../organisms/alias-history'
import {
  ComponentProps,
  TemplateResponseData,
} from '../../organisms/workflow-template/types'
import { useValidation } from '../../organisms/workflow-template/useValidation'
import { SubmitOnboardingCallback } from '../../pages/onboarding-workflow/OnboardingWorkflow'
import { CheckboxComponent } from './CheckboxComponent'
import { DateComponent } from './DateComponent'
import ImageComponent from './ImageComponent'
import { ListCellComponent } from './ListCellComponent'
import { ListComponent } from './ListComponent'
import { PasswordComponent } from './PasswordComponent'
import { PlaceOfBirthComponent } from './PlaceOfBirthComponent'
import { RadioGroupComponent } from './radio-group/RadioGroupComponent'
import { SelectComponent } from './SelectComponent'
import { TextFieldComponent } from './TextFieldComponent'
import { VGSDocUploadComponent } from './VGSDocUploadComponent'

type ComponentKeys =
  | 'DATE_FIELD'
  | 'TEXT_FIELD'
  | 'DROP_DOWN_FIELD'
  | 'CHECK_BOX_FIELD'
  | 'ADDRESS_HISTORY'
  | 'PREVIOUS_ALIAS'
  | 'PASSWORD_FIELD'
  | 'IMAGE'
  | 'LIST_FIELD'
  | 'VGS_DOC_UPLOAD'
  | 'SIGNATURE_CAPTURE'
  | 'LIST_CELL'
  | 'TEXT'
  | 'PLACE_OF_BIRTH'
  | 'RADIO_GROUP'

const COMPONENT_MAP: { [key in ComponentKeys]: Function } = {
  DATE_FIELD: DateComponent,
  TEXT_FIELD: TextFieldComponent,
  DROP_DOWN_FIELD: SelectComponent,
  CHECK_BOX_FIELD: CheckboxComponent,
  ADDRESS_HISTORY: AddressHistory,
  PREVIOUS_ALIAS: AliasHistory,
  PASSWORD_FIELD: PasswordComponent,
  IMAGE: ImageComponent,
  LIST_FIELD: ListComponent,
  VGS_DOC_UPLOAD: VGSDocUploadComponent,
  SIGNATURE_CAPTURE: SignatureCanvas,
  LIST_CELL: ListCellComponent,
  TEXT: Text,
  PLACE_OF_BIRTH: PlaceOfBirthComponent,
  RADIO_GROUP: RadioGroupComponent,
}

export const ComponentWrapper = (
  component: ComponentProps,
  templateResponseData: TemplateResponseData,
  onDataUpdate: (path: string, value) => void,
  onSubmitStep: SubmitOnboardingCallback
) => {
  const ComponentFromMap = COMPONENT_MAP[component.type]
  const { getError } = useValidation()

  if (ComponentFromMap) {
    const apiPath = component.be_mapping ? component.be_mapping.path : ''
    const value = get(templateResponseData, apiPath, '')
    // todo: this add creates a new function each render cycle, fully re-rendering the subsequent dom tree, there
    // should be a way to make it so react can be smart about this function
    const onChange = val => {
      onDataUpdate(apiPath, val)
    }
    const error = getError(apiPath)
    const id = uniqueId('component_')
    const props = {
      ...component.attributes,
      id,
      onChange,
      onSubmitStep,
      value,
      error,
      templateResponseData,
      apiPath,
    }
    return <ComponentFromMap {...props} />
  }
  console.warn(
    'Encountered a component which was not present in component_map',
    component.type
  )
  return null
}
